<template>
  <div class="page-order-add ivu-row-center" style="position: relative">
    <div class="title">{{ $t('page.order_add.title') }}</div>
    <Card :bordered="false" :shadow="false" class="order-form">
      <div class="form-list">
        <div v-for="(item, i) in mItems" :key="i">
          <Row>
            <Col span="5" :xs="6" class="gray-label">
              <span class="label">{{ $t('goods.name') }}</span>
            </Col>
            <Col span="19" :xs="18">{{ item.goods.name }}</Col>
          </Row>
          <Row>
            <Col span="5" :xs="6" class="gray-label">
              <span class="label">{{ $t('goods.price') }}</span>
            </Col>
            <Col span="19" :xs="18">
              <!-- 显示折扣价 -->
              <span v-if="item.goods.price !== item.goods.lastPrice" class="discount">
                <!--{{$tc('goods.discount', discountVal(item.goods.discount))}}-->
                <s>{{ YUAN }}{{ item.goods.price|amount }}</s>&nbsp;
              </span>
              <span class="price">{{ YUAN }}{{ item.goods.lastPrice }}</span>
              <span
                v-if="item.goods.price !== item.goods.lastPrice">&nbsp;({{ $tc('goods.discount', Math.round(item.goods.lastPrice * 100 / item.goods.price)) }})</span>
            </Col>
          </Row>
          <Row>
            <Col span="5" :xs="6" class="gray-label">
              <span class="label">{{ $t('page.order_add.buy_num') }}</span>
            </Col>
            <Col span="19" :xs="18">
              <span v-if="item.goods.stock===0" class="sellout">{{ $t('goods.tip_sellout') }}</span>
              <InputNumber v-else :min="1" :max="item.goods.limit_num"
                           v-model="item.num" @on-change="onOrderChanged"
                           style="width: 8em;text-align: center;" controls-outside></InputNumber>
              <!-- 库存 -->
              <span v-if="item.goods.stock<stockLow"
                    style="margin-left: 1em;">{{ $t('goods.label_stock') }}：{{ item.goods.stock }}</span>
              <span v-if="item.goods.stock<item.num"
                    class="sellout">&nbsp;{{ $t('goods.tip_not_enough') }}</span>
              <span v-if="item.area_not_support" style="padding-left: 10px;"
                    class="area-not-support">{{ $t('order.area_not_support') }}</span>
            </Col>
          </Row>
          <Row v-if="item.goods.extend && item.goods.extend.publish_sn">
            <Col span="5" :xs="6" class="gray-label">
              <span class="label">{{ $t('page.order_add.bind_type') }}</span>
            </Col>
            <Col span="19" :xs="18">
              <RadioGroup v-model="item.goods.extend.bind_type">
                <Radio :label="1">{{ $t('page.order_add.bind_yes') }}</Radio>
                <Radio :label="0">{{ $t('page.order_add.bind_no') }}</Radio>
              </RadioGroup>
            </Col>
          </Row>
          <Row v-if="!hideUrl && isAllowDiscount(item.goods)">
            <Col span="5" :xs="6" class="gray-label">
              <span class="label">{{ $t('page.order_add.use_discount') }}</span>
            </Col>
            <Col span="19" :xs="18">
              <div v-if="useDiscount" class="use-discount">
                <span class="discount-code-title">{{ $t('page.order_add.discount_code') }}:</span>
                <span class="code">{{ discount.code }}, -NT$ {{ discount.amount|amount }}</span>
                <span class="btn" @click.stop="removeDiscountCode">{{ $t('page.order_add.not_use_discount') }}</span>
              </div>
              <div v-else class="use-discount-form">
                <Input v-model="discountCode" @on-blur="onDiscountChanged(item.goods.id)"/>
                <div class="error-tip" v-if="discountError">{{ discountError }}</div>
              </div>
            </Col>
          </Row>
          <Row v-if="useCoin">
            <Col span="5" :xs="6" class="gray-label">
              <span class="label">{{ $t('page.order_add.use_coin') }}</span>
            </Col>
            <Col span="19" :xs="18">
              <div class="use-coin">
                <template v-if="useCoinAmount===0">
                  <span class="use-coin-tip" v-html="$t('page.order_add.max_use_coin',{n:maxUseCoin})"></span>
                  <span class="use-coin-btn" @click.stop="btnUseCoin">{{ $t('page.order_add.use') }}</span>
                </template>
                <template v-else>
                  <span class="use-coin-amount">-{{ YUAN }}{{ useCoinAmount }}</span>
                  <span class="use-coin-btn" @click.stop="btnUseCoin">{{ $t('page.order_add.no_use') }}</span>
                </template>
              </div>
            </Col>
          </Row>
        </div>

        <div v-if="hasTransport" class="transport">
          <Row>
            <Col span="5" :xs="6" class="gray-label">
              <span class="label">{{ $t('order.transport_way') }}</span>
            </Col>
            <Col span="19" :xs="18">{{ $t('order.way_logistics') }}</Col>
          </Row>
          <Row>
            <Col span="5" :xs="6" class="gray-label">
              <span class="label">{{ $t('order.transport_addr') }}</span>
            </Col>
            <Col span="19" :xs="18">
              <MyAddr v-if="mAddr" :value="mAddr" class="addr-item">
                <div slot="action-order" class="img-btn">
                  <img src="@/assets/icon-btn-edit.png" height="24" @click.stop="onAddrSelect" alt="">
                </div>
              </MyAddr>
              <Button v-else @click="onAddrSelect">{{ $t('page.addr.btn_new') }}</Button>
            </Col>
          </Row>
        </div>
        <!-- 发票信息 -->
        <div class="transport">
          <Row>
            <Col span="5" :xs="6" class="gray-label">
              <span class="label">{{ $t('invoice.title') }}</span>
            </Col>
            <Col span="19" :xs="18">
              <MyInvoice v-model="invoice"></MyInvoice>
            </Col>
          </Row>
        </div>
      </div>
    </Card>

    <div class="amount">
      <template v-if="mTotalAmount > mPayAmount">
        <hr class="my-hr">
        <Row>
          <Col span="6" class="label">{{ $t('order.total_amount') }}</Col>
          <Col span="18">{{ YUAN }}{{ mTotalAmount|amount }}</Col>
        </Row>
        <Row v-if="promotion.promotionAmount>0">
          <Col span="6" class="label">{{ $t('order.promotion_amount') }}</Col>
          <Col span="18">-{{ YUAN }}{{ promotion.promotionAmount|amount }}</Col>
        </Row>
        <Row v-if="promotion.discountAmount>0">
          <Col span="6" class="label">{{ $t('order.discount_amount') }}</Col>
          <Col span="18">-{{ YUAN }}{{ promotion.discountAmount|amount }}</Col>
        </Row>
        <Row v-if="useCoinAmount>0">
          <Col span="6" class="label">{{ $t('page.order_add.use_coin') }}</Col>
          <Col span="18">-{{ YUAN }}{{ useCoinAmount }}</Col>
        </Row>
        <template v-if="hasTransport">
          <Row>
            <Col span="6" class="label">{{ $t('order.freight_amount') }}</Col>
            <Col span="18">{{ YUAN }}0</Col>
          </Row>
          <Row>
            <Col span="6" class="label">{{ $t('order.freight_discount') }}</Col>
            <Col span="18">{{ YUAN }}0</Col>
          </Row>
        </template>
      </template>
      <hr class="my-hr">
      <Row class="order-total">
        <Col span="6" class="label">{{ $t('order.pay_amount') }}</Col>
        <Col span="18">{{ YUAN }}{{ mPayAmount|amount }}</Col>
      </Row>
    </div>
    <div>
      <div :style="{height:footerButtonHeight+'px'}"></div>
      <div ref="bottomButtons" class="bottom-buttons bottom-buttons-fixed">
        <Button class="btn btn-ok" long
                :loading="loading"
                @click="addOrder">{{ $t('page.order_add.btn_order_add') }}
        </Button>
        <Button class="btn" long
                @click.stop="$router.go(-1)">{{ $t('common.btn_back') }}
        </Button>
      </div>
    </div>
    <!-- 地址编辑 -->
    <div v-if="mAddrSelectShow" class="addressModal">
      <addresses @on-click="onAddrSave" @on-back="mAddrSelectShow=false" :is-window="true"></addresses>
    </div>
    <!-- 支付提示 -->
    <Modal v-model="mAlertPay" width="240"
           :mask-closable="false" :closable="false"
           class-name="warn-modal">
      <p slot="header">{{ $t('common.alert_title') }}</p>
      <p slot="footer">
        <Button @click="mAlertPay=false"
                class="alert-btn">{{ $t('common.btn_back') }}
        </Button>
        &nbsp;
        <Button @click="doOrder"
                class="alert-btn">{{ $t('common.btn_ok') }}
        </Button>
      </p>
      <p>{{ $t('page.order_add.tip_pay_confirm') }}</p>
    </Modal>
  </div>
</template>
<script>
    import { httpGetParams, httpPost, CancelToken } from '@/api/http';
    import Setting from '@/setting';
    import MyAddr from '@/components/MyAddr';
    import common from '../mixins/common';
    import Addresses from '@/views/Addresses';
    import MyInvoice from '@/components/MyInvoice';

    export default {
        components: {
            MyAddr,
            Addresses,
            MyInvoice
        },
        mixins: [common],
        data () {
            return {
                COIN_DEDUCTION_RATIO: 0.1, // 扣除币的比例10%
                YUAN: Setting.yuan,
                stockLow: Setting.stockLow,
                discountVal: Setting.convertDiscount,

                loading: false,

                mItems: [],

                sn_bind_def: 1,

                // 是否需要配送
                hasTransport: false,
                mTotalAmount: 0,
                mPayAmount: 0,
                discountCode: '',
                discount: null,
                useDiscount: false,
                hideUrl: false,
                userCoins: {},
                maxUseCoin: 0,
                useCoin: false,
                useCoinAmount: 0,

                service_head: require('@/assets/service.png'),

                mOrderForm: {
                    // id, num, extend{publish_sn, bind_type}
                    goods_list: [],
                    // 收貨地址ID
                    address_id: 0
                },

                mAddr: null,
                mAddrList: [],
                mAddrSelectShow: false,

                mAlertPay: false,
                discountError: '',
                promotion: {
                    promotionAmount: 0,
                    discountAmount: 0
                },
                invoice: {
                    type: 0,
                    id: 0,
                    invoice_head: '',
                    tax_id: ''
                }
            }
        },
        methods: {
            onOrderChanged () {
                const count = this.mItems.length;
                if (count === 0) {
                    this.$router.back();
                    return;
                }
                this.hasTransport = false;
                this.mTotalAmount = 0;
                this.mPayAmount = 0;
                this.promotion.promotionAmount = 0;
                this.promotion.discountAmount = 0;
                for (let i = 0; i < count; i++) {
                    const item = this.mItems[i];
                    const goods = item.goods;
                    if (!goods.is_virtual) {
                        this.hasTransport = true;
                    }
                    // 处理extend
                    const extend = goods.extend;
                    if (extend && extend.constructor === Array) {
                        const objs = {};
                        for (const i in extend) {
                            objs[extend[i]] = true
                        }
                        if (objs.publish_sn) {
                            objs.bind_type = this.sn_bind_def;
                        }
                        goods.extend = objs;
                    }

                    this.mTotalAmount += goods.price * item.num;
                    let allowDiscount = true
                    let price = goods.price
                    if (goods.promotions && goods.promotions.length > 0) {
                        price = goods.promotions[0].price
                        allowDiscount = goods.promotions[0].allow_discount
                        this.promotion.promotionAmount += (goods.price - price) * item.num
                    }
                    if (this.useDiscount && this.discount.goods_id === goods.id) {
                        if (allowDiscount) {
                            price -= this.discount.amount
                            this.promotion.discountAmount += (this.discount.amount) * item.num
                        } else {
                            this.useDiscount = false
                        }
                    }
                    if (price === goods.price && goods.discount < 1) {
                        price = this.$options.filters.discount_amount((goods.price * goods.discount))
                        this.promotion.promotionAmount += (goods.price - price) * item.num
                    }
                    goods.lastPrice = price
                    this.mPayAmount += price * item.num;
                }
                if (this.useCoin) {
                    this.maxUseCoin = Math.min(Math.floor(this.mPayAmount * this.COIN_DEDUCTION_RATIO), this.userCoins.coin_total - this.userCoins.coin_used)
                    if (this.useCoinAmount > this.maxUseCoin) {
                        this.useCoinAmount = this.maxUseCoin
                    }
                    this.mPayAmount -= this.useCoinAmount
                }

                return false;
            },
            onDiscountChanged (goodsId) {
                if (this.discountCode === '') {
                    return
                }
                const data = {
                    goods_id: goodsId,
                    code: this.discountCode
                }
                this.loading = true;
                this.$Spin.show();
                this.discountError = ''
                httpPost('/v1/discount/check', data).then(res => {
                    this.discount = res;
                    this.useDiscount = true;
                    this.onOrderChanged();
                }).catch(err => {
                    this.discountError = err.message
                }).finally(() => {
                    this.loading = false;
                    this.$Spin.hide();
                });
            },
            removeDiscountCode () {
                this.discount = null;
                this.discountCode = '';
                this.useDiscount = false;
                this.onOrderChanged();
            },
            // 下单
            addOrder () {
                for (const i in this.mItems) {
                    const item = this.mItems[i];
                    // 检查库存
                    if (item.num > item.goods.stock) {
                        this.$Modal.error({
                            title: this.$t('common.alert_title'),
                            content: this.$t('goods.alert_not_enough', { name: item.goods.name })
                        });
                        return;
                    }
                    // 检查地区
                    if (item.area_not_support) {
                        this.$Modal.error({
                            title: this.$t('common.alert_title'),
                            content: this.$t('order.area_not_support')
                        });
                        return;
                    }
                }
                if (this.hasTransport) {
                    if (!this.mAddr) {
                        this.$Message.error(this.$t('page.order_add.tip_invalid_addr'));
                        return;
                    }
                    this.mAlertPay = true;
                } else {
                    this.doOrder();
                }
            },
            // 执行下单
            doOrder () {
                this.loading = true;
                this.$Spin.show();
                const data = { ...this.mOrderForm };
                data.goods_list = [...this.mOrderForm.goods_list];
                if (this.hasTransport) {
                    data.address_id = this.mAddr.id;
                }
                // 使用的促销
                const promotions = []
                // 商品列表
                for (const i in this.mItems) {
                    const item = this.mItems[i];
                    const goods = item.goods;
                    const info = {
                        id: goods.id,
                        num: item.num
                    };
                    if (goods.extend) {
                        info.extend = goods.extend;
                    }
                    if (goods.promotions && goods.promotions.length > 0) {
                        promotions.push(goods.promotions[0].id)
                    }
                    data.goods_list.push(info);
                }
                if (this.useDiscount) {
                    data.discount_code = this.discountCode;
                }
                if (promotions.length > 0) {
                    data.promotions = promotions
                }
                if (this.useCoin && this.useCoinAmount > 0) {
                    data.use_coin = this.useCoinAmount
                }
                data.invoice = this.invoice

                httpPost('/v2/mall/order', data).then(res => {
                    if (typeof res === 'number' || typeof res === 'string') {
                        this.$router.face.pay(res);
                        return;
                    }
                    this.$nextTick(() => {
                        this.loading = false;
                        this.$Spin.hide();
                        this.$router.face.orderPay(res);
                    });
                }).catch(() => {
                    this.loading = false;
                    this.$Spin.hide();
                });
            },
            onAddrSelect () {
                this.mAddrSelectShow = true;
            },
            onAddrListReady () {
                if (this.mAddrList.length > 0) {
                    this.mAddr = this.mAddrList[0];
                    for (let i = 0; i < this.mAddrList.length; i++) {
                        if (this.mAddrList[i].is_default) {
                            this.mAddr = this.mAddrList[i];
                            break;
                        }
                    }
                } else {
                    this.mAddr = null;
                }
                this.onCheckAddr();
            },
            onAddrSave (addr) {
                this.mAddr = addr;
                this.mAddrSelectShow = false
                this.onCheckAddr();
            },
            // 检查地区是否支持
            onCheckAddr () {
                const count = this.mItems.length;
                for (let i = 0; i < count; i++) {
                    const item = this.mItems[i];
                    const goods = item.goods;
                    if (goods.is_virtual || !this.mAddr) {
                        item.area_not_support = false;
                        continue;
                    }
                    // 检查地址中是否存在支持的区域
                    let support = true;
                    if (goods.areas && goods.areas.length > 0) {
                        support = false;
                        for (let j = 0; j < goods.areas.length; j++) {
                            const id = goods.areas[j];
                            if (this.mAddr.area_ids.indexOf(id) >= 0) {
                                support = true;
                                break;
                            }
                        }
                    }
                    item.area_not_support = !support;
                }
            },
            // 查询商品以准备订单
            readyOrder (items) {
                if (this.cancel) {
                    this.cancel();
                    this.cancel = null;
                }
                this.loading = true
                this.$Spin.show();
                let ids = '';
                for (const i in items) {
                    const item = items[i];
                    if (item.id) {
                        if (ids) {
                            ids += ',';
                        }
                        ids += item.id;
                    }
                    if (item.discountCode) {
                        this.discount = item.discountCode
                        this.discountCode = item.discountCode.code
                        this.useDiscount = true
                        this.hideUrl = true
                    }
                }

                httpGetParams('/v1/goods/search', {
                    ids
                }, new CancelToken((c) => {
                    this.cancel = c
                })).then(res => {
                    if (res.length === 0) {
                        this.loading = false
                        this.$Spin.hide();
                        this.cancel = null;
                        this.$Message.error(this.$t('goods.tip_no_exist'));
                        return;
                    }
                    const map = {};
                    for (const i in res) {
                        const item = res[i];
                        map[item.id] = item;
                    }

                    let useCoin = false;
                    for (const i in items) {
                        const item = items[i];
                        if (!item.id) {
                            continue;
                        }
                        const goods = map[item.id];
                        if (!goods) {
                            this.$Message.error(this.$t('goods.tip_no_exist'));
                            return;
                        }
                        if (!(item.num > 0)) {
                            item.num = 1;
                        }
                        //
                        this.mItems.push({
                            goods: goods,
                            num: item.num
                        });
                        if (goods.use_coin) {
                            useCoin = true;
                        }
                    }
                    if (useCoin) {
                        this.getUserCoins();
                    }
                    this.onOrderReady();
                }).catch(() => {
                    this.$router.back();
                }).finally(() => {
                    this.loading = false;
                    this.$Spin.hide();
                    this.cancel = null;
                });
            },
            // 订单已准备好
            onOrderReady () {
                this.onOrderChanged();
                if (this.$store.state.addresses) {
                    this.mAddrList = this.$store.state.addresses;
                    this.onAddrListReady();
                }
                // 刷新加载收货地址列表
                this.$store.dispatch('loadAddresses').then((addresses) => {
                    this.mAddrList = addresses;
                    this.onAddrListReady();
                }).catch(() => {
                }).finally(() => {
                });
            },
            isAllowDiscount (goods) {
                let allow = true
                if (goods.promotions && goods.promotions.length > 0) {
                    allow = goods.promotions[0].allow_discount
                }
                return allow
            },
            getUserCoins () {
                httpGetParams('/v2/mega/coin').then(res => {
                    if (res != null && res.coin_total - res.coin_used > 0) {
                        this.userCoins = res
                        this.useCoin = true
                        this.onOrderChanged();
                    }
                })
            },
            btnUseCoin () {
                if (this.useCoinAmount > 0) {
                    this.useCoinAmount = 0
                    this.onOrderChanged()
                } else {
                    const gap = Math.floor(this.maxUseCoin / 5)
                    const marks = {
                        0: '0'
                    }
                    for (let i = 1; i < 5; i++) {
                        marks[i * gap] = this.YUAN + i * gap
                    }
                    marks[this.maxUseCoin] = {
                        style: {
                            color: '#ff0606'
                        },
                        label: this.YUAN + this.maxUseCoin
                    }
                    let value = 0
                    this.$Modal.confirm({
                        render: (h) => {
                            return h('Slider', {
                                style: {
                                    padding: '20px 0'
                                },
                                props: {
                                    value: this.value,
                                    autofocus: true,
                                    min: 0,
                                    max: this.maxUseCoin,
                                    step: 1,
                                    marks: marks
                                },
                                on: {
                                    input: (val) => {
                                        value = val;
                                    }
                                }
                            })
                        },
                        title: this.$t('page.order_add.input_coin_tip'),
                        onOk: () => {
                            this.useCoinAmount = value
                            this.onOrderChanged()
                        },
                        onCancel: () => {
                            this.useCoinAmount = 0
                            this.onOrderChanged()
                        }
                    })
                }
            }
        },
        created () {
            const route = this.$route;
            const order = route.params.order;
            if (order && typeof order === 'object') {
                this.readyOrder(order.items);
            } else if (route.params.autoLogin && route.query.id) {
                this.readyOrder([
                    {
                        id: route.query.id,
                        num: route.query.num
                    }
                ]);
            } else {
                this.$Message.error(this.$t('common.err_param'));
                this.$router.back();
            }
        },
        beforeDestroy () {
            if (this.cancel) {
                this.cancel();
                this.cancel = null;
            }
        }
    }
</script>

<style lang="scss">
.page-order-add {
  .order-form {
    text-align: left;

    .ivu-card-body {
      padding: 20px;
    }

    .form-list {
      display: flex;
      flex-direction: column;
      border-top: 1px solid #c6c6c6;

      & > div {
        margin-bottom: 2px;
      }

      .transport {
        border-top: 1px solid #c6c6c6;
        margin-top: 3px;
      }

      .sellout {
        color: #FF9900;
      }

      .area-not-support {
        color: #FF9900;
      }

      .ivu-col {
        //font-size: .8rem;
        padding: 10px;
        border-right: 1px solid #c6c6c6;
        border-bottom: 1px solid #c6c6c6;
        display: flex;
        align-items: center;

        .ivu-input-number-controls-outside-btn {
          background-color: #dcdddd;
          color: #000;
        }

        input {
          //text-align: center;
          font-size: .8rem;
        }

        input.ivu-input-number-input {
          text-align: center;
        }

        .ivu-radio-wrapper {
          font-size: .8rem;
        }
      }

      .ivu-col:first-child {
        border-left: 1px solid #c6c6c6;
        padding: 0px;
      }

      .gray-label {
        background-color: #dcdddd;
        font-weight: bold;
      }

      .label {
        width: 100%;
        text-align: center;
      }

      .price {
        color: #ff0606;
      }

      .use-discount {
        display: flex;
        align-items: flex-start;

        .discount-code-title {
          color: #FF9900;
        }

        .code {
          flex: 1;
        }

        .btn {
          margin-left: 10px;
          color: #428dfb;
          cursor: pointer;

          &:hover {
            opacity: 0.8;
          }
        }
      }

      .use-discount-form {
        width: 100%;

        .error-tip {
          padding-top: 10px;
          color: #ff0606;
        }
      }
    }
  }

  .amount {
    font-weight: bold;

    & > div {
      display: flex;
      padding: 5px;
      align-items: center;

      & > div:first-child {
        width: 30%;
      }
    }

    .order-total {
      font-size: 1.2rem;
      font-weight: bold;
    }

    .label {
      text-align: right;
    }

    .ivu-col {
      padding: 5px;
    }
  }
}

.addressModal {
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 9;
  top: 0;
  left: 0;
  background-color: #ffffff;
}

.use-coin {
  display: flex;
  align-items: flex-start;

  &-tip {
    flex: 1;
    &>span{
      font-weight: bold;
      color: #ff0606;
    }
  }
  &-amount {
    flex: 1;
    color: #ff0606;
    font-weight: bold;
  }

  &-btn {
    margin-left: 10px;
    color: #428dfb;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
